import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Campaign } from '../../campaign.component';

@Component({
  selector: 'df-campaign-key-message',
  templateUrl: './campaign-key-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignKeyMessageComponent {
  @Input() campaign!: Campaign;
}
